'use client'

import { LeadForm } from '@/components/LeadForm'
import { Layout } from '@/components/Layout'
import { LeadSell } from '@/components/LeadSell'
import { Suspense } from 'react'

export const dynamic = 'force-dynamic'

export default function Signup() {
  return (
    <Layout>
      <Suspense fallback={<div />}>
        <div className="flex items-center justify-center">
          <LeadForm
            title={'Start your 14 day free trial'}
            subtitle={'Unlock instant savings. No credit card required.'}
            callToAction={'Sign Up'}
            successMessage={
              "Thanks for signing up! We'll send you a product invitation and setup instructions via email within the next 24 hours. If you don't see it, please check your spam folder, or reach out via the chat bubble."
            }
          />
        </div>
      </Suspense>
      <LeadSell
        titleText="Get up and running in less than 15 minutes and"
        shinyTitleText="automatically optimize your Snowflake usage"
      />
    </Layout>
  )
}
